import { upsertBankAccount } from "lib/api/bankAccount/upsertBankAccount"
import { useMutation } from "@tanstack/react-query"

const useUpsertBankAccount = () => {
  return useMutation((payload) => upsertBankAccount(payload))
}

export default useUpsertBankAccount
